import React from "react";

import NotFoundIcon from "../icons/not-found.svg";

import HelpSearch from "../help/help-search";
import "../help/help.scss";
import { useCommonContext } from "../../context/common-context";

const NotFound = ({}) => {
  const {
    user,
    appData: { banner: bannerName },
    isGuest,
  } = useCommonContext();

  const banner = bannerName.charAt(0).toUpperCase() + bannerName.slice(1);
  //   const history = useHistory();

  //   const handleSeeAll = () => {
  //     history.push('/all-faq/1');
  //   };

  return (
    <div className="help-wrapper">
      <HelpSearch isGuest={isGuest} banner={banner} />
      <div className="p-5 text-center">
        <h2 className="font-weight-bold">404 error. Page not found.</h2>
        <p>
          {" "}
          Go back to <span className="homepage-nav">home page</span>
        </p>
        <img src={NotFoundIcon} alt="not-found" />
      </div>
    </div>
  );
};

export default NotFound;
